import { createUserSessionContext, type UserSessionContext } from '@shared/lib'

/**
 * Контекст возврата из PROCTOR.
 *
 * Прокторинг уводит участника со страницы обычным переходом, а возвращает на
 * адрес из своей настройки (`PROCTOR_RETURN_URL`, сейчас — корень сайта). По
 * корню неоткуда узнать, какую олимпиаду он писал, поэтому ID запоминается
 * перед уходом и читается после возврата.
 *
 * Хранится в `sessionStorage`, а не в `localStorage`: это контекст одного
 * похода, он не должен пережить закрытие вкладки и всплыть через неделю.
 *
 * Запись привязана к участнику. Полагаться на очистку при выходе нельзя —
 * `authTokens.clear()` вызывается из трёх мест (выход, провал инициализации,
 * провал refresh), и любое из них может не дойти сюда; а вот чужой `userId`
 * виден всегда, и такая запись просто игнорируется. Так следующий вошедший в
 * этой же вкладке не попадёт на чужую олимпиаду.
 *
 * Токенов и ссылки запуска здесь нет: одноразовый `redirect_url` не
 * сохраняется нигде (требование контракта).
 */
const store = createUserSessionContext('proctor_return', 'olympiadId')

export type ProctorReturnContext = UserSessionContext<'olympiadId'>

/**
 * Запомнить, куда вернуть участника. Вызывается перед переходом в PROCTOR. Недоступное
 * хранилище (приватный режим Safari и т. п.) запуск не срывает: потерянный контекст — это лишний
 * шаг для участника, а исключение уронило бы сам запуск олимпиады.
 */
export function saveProctorReturn(context: ProctorReturnContext): void {
  store.save(context)
}

/** Контекст текущего участника, если он есть и принадлежит именно ему. */
export function readProctorReturn(userId: number | null | undefined): ProctorReturnContext | null {
  return store.read(userId)
}

/** Забыть контекст — на выходе из аккаунта и после того, как он отработал. */
export function clearProctorReturn(): void {
  store.clear()
}
